import { render, staticRenderFns } from "./Microchip.vue?vue&type=template&id=7d7ee1a6&"
import script from "./Microchip.vue?vue&type=script&lang=js&"
export * from "./Microchip.vue?vue&type=script&lang=js&"
import style0 from "./Microchip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports